import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static targets = ["button", "input"];
  static values = { addLabel: String, removeLabel: String };

  toggle() {
    const selected = this.buttonTarget.getAttribute("aria-pressed") !== "true";

    this.buttonTarget.setAttribute("aria-pressed", selected.toString());
    this.buttonTarget.setAttribute(
      "aria-label",
      selected ? this.removeLabelValue : this.addLabelValue,
    );
    this.inputTarget.value = selected ? "0" : "";
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }));
  }
}
